import { useEffect, useRef, useState } from "react";

import { MarketType } from "../../../types";
import { ResendCooldownTimeJP } from "../constants";

// The API doesn't block repeated requests, so Japan enforces the resend cooldown on the frontend.
export default function useResendCooldownJP(
  market: MarketType,
  account: string,
) {
  const [cooldownAccount, setCooldownAccount] = useState("");

  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  // Only block re-sending to the same email or phone number.
  const isResendBlocked = cooldownAccount !== "" && account === cooldownAccount;
  const resendBlockedMessageJP = isResendBlocked
    ? "再送可能になるまでしばらくお待ちください。"
    : "";

  const startResendCooldown = () => {
    if (market !== "JP") return;

    clearTimeout(timerRef.current);
    setCooldownAccount(account);

    timerRef.current = setTimeout(
      () => setCooldownAccount(""),
      ResendCooldownTimeJP * 1000,
    );
  };

  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);

  return {
    isResendBlocked,
    resendBlockedMessageJP,
    startResendCooldown,
  };
}
